/* eslint-disable no-unused-vars */
import React from 'react';
import { Buttons } from 'components';
import PropTypes from 'prop-types';

import * as S from './ModalFooter.styled';

const ModalFooter = ({
  saveButtonText,
  saveButtonOnClick,
  saveButtonDisabled,
  close,
  saveButtonType = null,
  form = null,
  children,
}) => {
  return (
    <S.Footer>
      {children}
      <S.GroupButtons>
        <Buttons.SecondaryNormal id='close-modal-btn' onClick={close}>
          Cancel
        </Buttons.SecondaryNormal>
        <Buttons.PrimaryNormal
          form={form}
          id='save-modal-btn'
          type={saveButtonType}
          onClick={saveButtonOnClick}
          isDisabled={saveButtonDisabled}
        >
          {saveButtonText}
        </Buttons.PrimaryNormal>
      </S.GroupButtons>
    </S.Footer>
  );
};

ModalFooter.propTypes = {
  saveButtonText: PropTypes.string.isRequired,
  saveButtonOnClick: PropTypes.func.isRequired,
  saveButtonDisabled: PropTypes.bool,
  close: PropTypes.func.isRequired,
  saveButtonType: PropTypes.string,
  form: PropTypes.string,
  children: PropTypes.node,
};

export default ModalFooter;
